const doc = [({"da":({"js":({"agenda_item_elements":({"edit":({"image":({"choose_image_file":"Vælg billedfil"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;